<style scoped>
  .hint {
    margin-right: 1rem;
    padding:-0.5rem
  }

  .itemselected{
    background-color: #E1F5FE;
    border-style: solid;
    border-width: 0em 0em 0em 0.3em;
    border-color: #42A5F5;
  }
  .sidebaritems:hover{
    background-color: #42A5F5;
  }
  .sidebaritems{}
</style>
<template>

    <v-container fill-height fluid style="position:absolute;left:0;top:0;bottom:0;right:0;overflow-y:scroll;padding:0">
        <v-btn v-on:click="drawer=!drawer" absolute bottom fab style="z-index:3;bottom:1rem;left:1rem" dark color="purple"><v-icon>menu</v-icon></v-btn>
        <v-layout row wrap>
            <v-navigation-drawer
                    absolute
                    v-model="drawer"
                    :temporary="($vuetify.breakpoint.sm | $vuetify.breakpoint.xs)? true: false" 
                    :style="'width: 30rem;padding:1rem;left:'+(!drawer?'-30rem':'')"
            >
              <div style="text-align:left; margin:0.5rem;margin-bottom:0.5rem">
                <div class="headline">Settings</div>
                <div class="body-1">Configure dashboard in order to be integrated with external services.</div>
                </div>

                <v-layout 
                    row wrap align-center
                    style="
                        padding-left:1rem;
                        padding-right:1rem;
                        margin-bottom:1rem"
                >
                    <v-flex xs12 sm12 md12>
                      <v-list two-line>
                        <v-list-tile v-on:click="view=0" v-bind:class="{ itemselected: view==0 }">
                          <v-list-tile-action>
                            <v-icon color="blue" small class="blue lighten-5 elevation-1" style=" padding:0.3rem">
                              {{appMetadata.settings.apiKeys.icon}}
                            </v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>{{appMetadata.settings.apiKeys.title}}</v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile  v-on:click="view=1" v-bind:class="{ itemselected: view==1 }">
                          <v-list-tile-action>
                            <v-icon color="teal"  small class="teal lighten-5 elevation-1" style=" padding:0.3rem">
                              {{appMetadata.settings.deviceProfiles.icon}}
                            </v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>{{appMetadata.settings.deviceProfiles.title}}</v-list-tile-title>
                        </v-list-tile>

                        <v-list-tile  v-on:click="view=2" v-bind:class="{ itemselected: view==2 }">
                          <v-list-tile-action>
                            <v-icon color="purple"  small class="purple lighten-5 elevation-1" style=" padding:0.3rem">
                              {{appMetadata.settings.dataConverters.icon}}
                            </v-icon>
                          </v-list-tile-action>
                          <v-list-tile-title>{{appMetadata.settings.dataConverters.title}}</v-list-tile-title>
                        </v-list-tile>
                      </v-list>
                    </v-flex>
                </v-layout>
            </v-navigation-drawer>
            <v-flex xs12 :style="'height:100%;margin-left:'+(!($vuetify.breakpoint.sm | $vuetify.breakpoint.xs) && drawer?'30rem':'0')" >
                <apikeys theme="blue" v-if="view==0"></apikeys>
                <deviceprofiles theme="teal" v-if="view==1"></deviceprofiles>
                <dataconverters theme="purple" v-if="view==2"></dataconverters>
            </v-flex>
        </v-layout>
    </v-container>












  <!-- <div style="
        position:absolute;
        left:0;top:0;bottom:0;right:0;overflow-y:scroll;
        margin-left:1rem;margin-top:2rem">
    <v-container>
      <v-layout row wrap align-start class="" style="text-align:left"> 
          <v-flex xs12 class="display-1">Settings </v-flex>
          <v-flex xs12 class="headline-1">Configure dashboard in order to be integrated with external services.</v-flex>
      </v-layout>
    </v-container>
    <v-container elevation-1 class="telemetry-container white"   style="">
      <v-layout row wrap  align-content-start >
        <v-flex xs3 >
        <v-navigation-drawer
          stateless
          value="true"
          class="text-uppercase"
        >
          <v-list>
            <v-list-tile v-on:click="view=0" v-bind:class="{ itemselected: view==0 }">
              <v-list-tile-action>
                <v-icon color="blue" small class="blue lighten-5 elevation-1" style=" padding:0.3rem">
                  {{appMetadata.settings.apiKeys.icon}}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{appMetadata.settings.apiKeys.title}}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile  v-on:click="view=1" v-bind:class="{ itemselected: view==1 }">
              <v-list-tile-action>
                <v-icon color="teal"  small class="teal lighten-5 elevation-1" style=" padding:0.3rem">
                  {{appMetadata.settings.deviceProfiles.icon}}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{appMetadata.settings.deviceProfiles.title}}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile  v-on:click="view=2" v-bind:class="{ itemselected: view==2 }">
              <v-list-tile-action>
                <v-icon color="purple"  small class="purple lighten-5 elevation-1" style=" padding:0.3rem">
                  {{appMetadata.settings.dataConverters.icon}}
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{appMetadata.settings.dataConverters.title}}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-navigation-drawer>
        </v-flex>
        <v-flex xs9>
          <div>
              <apikeys theme="blue" v-if="view==0"></apikeys>
              <deviceprofiles theme="teal" v-if="view==1"></deviceprofiles>
              <dataconverters theme="purple" v-if="view==2"></dataconverters>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <inprogress  :dialog="operationInProcess" :message="operationInProcessMessage" ></inprogress>
  </div>  -->
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name:"Settings",
  components:{
    deviceprofiles: require('./content-components/DeviceProfiles').default,
    apikeys: require('./content-components/ApiKeys').default,
    dataconverters: require('./content-components/DataConverters').default,

    // editor: require('vue2-ace-editor'),
    // itemlist: require('../ItemList').default
  },

  data: function(){
    return {
      view: 0,
      deviceProfile: null,
      drawer: true,
      refreshDeviceProfilesHint:false,
      refreshApiKeysHint:false,
      openDeviceProfileRegistrationProcess:false,
      openApiKeyRegistrationProcess:false,
      neuralNetworkModelsSelected:[],
      neuralNetworkFirmwaresSelected:[],
      firmwaresSelected:[],
      colors:["teal","purple","yellow","red","blue"],
      firmwaresMetadata:[
        {
          text: 'File name',
          align: 'left',
          sortable: true,
          value: 'name'
        }              
      ]
    }
  },

computed:{
  ...mapState(
    {
        lastOperationMessage:'lastOperationMessage',
        lastOperationSuccess:'lastOperationSuccess',
        operationInProcess:'operationInProcess',
        operationInProcessMessage: 'operationInProcessMessage',
        deviceProfiles: state => state.deviceProfiles.deviceProfiles,
        dataConverters: state => state.deviceProfiles.dataConverters,
        apiKeys: state => state.apiKeys.apiKeys,
        firmwares : state => state.devices.firmwares,
        neuralNetworkFirmwares : state => state.devices.neuralNetworkFirmwares,
        neuralNetworkModels : state => state.devices.neuralNetworkModels,
        appMetadata: state => state.metadata.models.views
    }
  ),
  ...mapGetters(
    {
      groupName: 'authentication/getUserName'
    }
  )
},

watch:{
  neuralNetworkModelsSelected:{
    deep:true,
    handler: function(){
      if(this.neuralNetworkModelsSelected.length>1)
        this.neuralNetworkModelsSelected.shift()
    }
  }
},

methods:{
    editorInit: function () {
        require('brace/ext/language_tools') //language extension prerequsite...
        require('brace/mode/html')                
        require('brace/mode/javascript')    //language
        require('brace/mode/less')
        require('brace/theme/chrome')
        require('brace/snippets/javascript') //snippet
    },

    removeSelectedFirmwares(){
      if(this.firmwaresSelected.length<=0)
        return
      let firmwares = this.firmwaresSelected.map((item)=>{return {name: item.name, type:item.type}})
      this.firmwaresSelected = []
      this.$store.dispatch('devices/removeFirmwares',firmwares)
    },

    uploadFirmware: function(firmware){
      let reader = new FileReader()
      reader.vuecontext = this
      reader.onload = function() {
          let arrayBuffer = this.result
          let fileTypedArray = new Uint8Array(arrayBuffer)
          let fileNormalArray = Array.prototype.slice.call(fileTypedArray)
          reader.vuecontext
            .$store.dispatch(
              'devices/uploadFirmware',
              {
                name: firmware.name,
                file: fileNormalArray
              }
            )
      }
      reader.readAsArrayBuffer(firmware)
    },

    uploadNeuralNetworkFirmware: function(firmware){
      let reader = new FileReader()
      reader.vuecontext = this
      reader.onload = function() {
          let arrayBuffer = this.result
          let fileTypedArray = new Uint8Array(arrayBuffer)
          let fileNormalArray = Array.prototype.slice.call(fileTypedArray)
          reader.vuecontext
            .$store.dispatch(
              'devices/uploadFirmware',
              {
                name: firmware.name,
                file: fileNormalArray,
                type: 'neural'
              }
            )
      }
      reader.readAsArrayBuffer(firmware)
    },

    uploadNeuralNetworkModel: function(firmware){
      let reader = new FileReader()
      reader.vuecontext = this
      reader.onload = function() {
          let arrayBuffer = this.result
          let fileTypedArray = new Uint8Array(arrayBuffer)
          let fileNormalArray = Array.prototype.slice.call(fileTypedArray)
          reader.vuecontext
            .$store.dispatch(
              'devices/uploadFirmware',
              {
                name: firmware.name,
                file: fileNormalArray,
                type: 'model'
              }
            )
      }
      reader.readAsArrayBuffer(firmware)
    },

    removeSelectedNeuralNetworkFirmwares(){
      if(this.neuralNetworkFirmwaresSelected.length<=0)
        return
      let firmwares = this.neuralNetworkFirmwaresSelected.map((item)=>{return {name: item.name, type:'neural'}})
      this.neuralNetworkFirmwaresSelected = []
      this.$store.dispatch('devices/removeFirmwares',firmwares)
    },

    removeSelectedNeuralNetworkModels(){
      if(this.neuralNetworkModelsSelected.length<=0)
        return
      let firmwares = this.neuralNetworkModelsSelected.map((item)=>{return {name: item.name, type:'model'}})
      this.neuralNetworkModelsSelected = []
      this.$store.dispatch('devices/removeFirmwares',firmwares)
    },


  }
}
</script>